var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","color":"success"},domProps:{"textContent":_vm._s(_vm.$ml.get('excel'))},on:{"click":_vm.exportExcel}})
}
var staticRenderFns = []

export { render, staticRenderFns }